import { MdClose } from "react-icons/md";

interface AIPromptPillProps {
  prompt: { text: string; primary: boolean };
  setPrompts: React.Dispatch<
    React.SetStateAction<{ text: string; primary: boolean }[]>
  >;
}

const AIPromptPill: React.FC<AIPromptPillProps> = ({ prompt, setPrompts }) => {
  /**
   * Function executed when clicking the cross on the pill
   */
  const handleCloseClick = () => {
    // Remove this item from the selected prompts list
    setPrompts((currentList) =>
      currentList.filter(
        (item: { text: string; primary: boolean }) => prompt.text !== item.text
      )
    );
  };

  return (
    <div
      className={`pl-3 pr-2 py-2 ${
        prompt.primary
          ? "bg-[#D9F3F5] text-[#0A434B]"
          : "bg-neutral-50 text-neutral-700"
      } rounded-3xl flex justify-start items-center gap-2`}
    >
      <div className="justify-start text-base font-normal font-sans leading-tight select-none">
        {prompt.text}
      </div>
      <div
        className="w-5 h-5 rounded-full hover:bg-neutral-200 ease-in-out duration-150 inline-flex justify-center items-center cursor-pointer"
        onClick={handleCloseClick}
      >
        <MdClose className="w-4 h-4 fill-neutral-700" />
      </div>
    </div>
  );
};

export default AIPromptPill;
